export type UseChartbeatSettingsProps = {
  enabled: boolean;
}

export function useChartbeatSettings({ enabled }: UseChartbeatSettingsProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      <script key='chartbeat-settings' async type='text/javascript' src='/scripts/chartbeat-settings.js?v=1.2' />
    </>
  )
}
